import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { toast } from 'react-hot-toast';
import { Link, useNavigate, useParams } from "react-router-dom";

import ButtonLoader from "./ButtonLoader";

import AseLogo from '../assets/ase-logo.png';
import { ArrowUturnLeftIcon } from "@heroicons/react/24/outline";

import authService from '../services/authService';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    const fetchForgotPasswordRequest = async () => {
      try {
        await authService.fetchForgotPasswordRequest({ forgotPasswordRequestId: params.id });
      } catch (error) {
        toast.error('Invalid reset password link');
        navigate('/login');
      }
    }

    fetchForgotPasswordRequest();
  }, [navigate, params.id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    if (newPassword && newPassword !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    try {
      await authService.resetPassword({
        forgotPasswordRequestId: params.id,
        newPassword: newPassword
      });

      toast.success('Password reset successful');
      navigate('/login');
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center flex-grow min-h-screen px-2">
      <Helmet>
        <title>Reset password | ASE Group</title>
      </Helmet>

      <img src={AseLogo} alt="ASE Group" className='h-[50px] mb-10' />

      <div className='flex flex-col items-center justify-center min-w-full'>
        <form className='border border-gray-300 rounded-lg flex flex-col gap-4 w-full md:w-[550px] p-[32px] mb-4 shadow-md bg-white' onSubmit={handleSubmit}>
          <label className='flex flex-col gap-1'>
            <span>New Password</span>

            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </label>

          <label className='flex flex-col gap-1'>
            <span>Confirm Password</span>

            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </label>

          <button
            type="submit"
            className="w-full bg-ase-blue font-semibold text-white h-[48px] rounded-md disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
            disabled={newPassword ? newPassword !== confirmPassword : true}
          >
            {isLoading ? <ButtonLoader /> : 'Reset password'}
          </button>

          <div className="flex items-center justify-center gap-1 mt-1">
            <ArrowUturnLeftIcon className="h-5 w-5 text-ase-blue" />
            <Link to="/login" className="text-ase-blue">Back to login</Link>
          </div>
        </form>
      </div>
    </div >
  )
}

export default ResetPassword;
